import React, { useEffect, useRef, useState } from 'react'
import { handleLoader } from 'redux/counterSlice'
import { getDynamicPricingData, getDynamicPricingGraphData, getUniqueProducts } from 'services/dynamicPricingService'

import { useDispatch } from "react-redux"
import { toast } from 'react-toastify'

import { MultiSelect, MultiSelectChangeEvent } from 'primereact/multiselect'
import { Button } from 'primereact/button'
import { Toast } from 'primereact/toast'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'


import dynamicActionButton from '../../assets/icons/dynamic-action.svg'
import DynamicGraph from 'components/dynamic-pricing/DynamicGraph'
import { shortenString } from 'utils/helper'
import { Paginator } from 'primereact/paginator'
import { useSearchParams } from 'react-router-dom'

export interface DynamicPricingDataPayload {
  client_env: string
  page: number,
  size_limit: number,
  product_name: string[]
}



export interface DynamicGraphData {
  product_id: string
  product_name: string
  forecast: {
    week_start: string
    forecast_price: number
  }[]
  // history: {
  //   week_start: string
  //   history_price: number
  // }[]
}

export interface DynamicGridData {
  status: string
  message: string
  total_count: number
  result: any[]
}

export interface UniqueProducts {
  product_id: string
  product_name: string
}

interface ColumnMeta {
  field: string;
  header: string;
}

const DynamicPricing = () => {

  const dispatch = useDispatch()
  const [payloadData, setPayloadData] = useState<DynamicPricingDataPayload>({
    client_env: localStorage.getItem("clientName") as string,
    page: 1,
    size_limit: 20,
    product_name: []
  })


  const [dynamicGraphData, setDynamicGraphData] = useState<DynamicGraphData[]>()
  const [dynamicGridData, setDynamicGridData] = useState<DynamicGridData>()
  const [unique_products, set_unique_products] = useState<UniqueProducts[]>([])
  const [temp_unique_products, set_temp_unique_products] = useState<UniqueProducts[]>([])
  const [expandedRows, setExpandedRows] = useState<any[]>([]);

  const [searchParams] = useSearchParams()
  const firstinstance: number | null = searchParams.get("first") !== null ? Number(searchParams.get("first")) : 0
  const [first, setFirst] = useState<number>(firstinstance)
  const dynamicProductRef: any = useRef()
  const toastRef = useRef<Toast>(null);
  const [SearchByName, setSearchByName] = useState<boolean>(true)
  const [columns, setColumns] = useState<any>([])


  const [selectedCustomers, setSelectedCustomers] = useState<UniqueProducts[]>([]);

  useEffect(() => {
    fetchProducts()
    fetchGridData(payloadData)

  }, [])


  useEffect(() => {


    const tempList: UniqueProducts[] = unique_products?.filter((item) => (payloadData.product_name?.includes(item.product_name) && item))

    const newItems = [
      ...tempList,
      ...unique_products?.filter((item) => payloadData.product_name && !payloadData.product_name.includes(item.product_name) && item) // Unselected items
    ];

    set_temp_unique_products(newItems)

  }, [payloadData.product_name])

  useEffect(() => {
    dynamicGridData && fetchGridData(payloadData)
  }, [payloadData.page])

  //api calls

  const fetchProducts = async () => {

    try {

      dispatch(handleLoader(true))

      const { result, error } = await getUniqueProducts()
      if (error) {
        throw error
      }
      const tempResult = result.sort((a: UniqueProducts, b: UniqueProducts) => a.product_name.localeCompare(b.product_name))
      set_unique_products(tempResult)
      set_temp_unique_products(tempResult)

    } catch (error: any) {
      dispatch(handleLoader(false))
      toast.error(error, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      })
    }

  }




  const fetchGridData = async (payload: DynamicPricingDataPayload) => {

    try {

      dispatch(handleLoader(true))

      const { result, error } = await getDynamicPricingData(payload)
      if (error) {
        throw error
      }


      const columns = createDynamicColumns(result?.result[0]);
      setDynamicGridData(result)
      setColumns(columns)

      dispatch(handleLoader(false))
    } catch (error: any) {
      dispatch(handleLoader(false))
      toast.error(error, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      })
    }
  }


  //template code
  const productItemTemplate = (option: any) => {


    const productLabel = SearchByName ? option?.product_name : option?.product_id
    const shortStringLabel = shortenString(SearchByName ? option?.product_name : option?.product_id, 31)
    return (
      <div className="flex align-items-center">
        <div title={productLabel}>{shortStringLabel} </div>
      </div>
    );
  };

  const productFooterTemplate = () => {

    function handleClear() {

      setPayloadData({ ...payloadData, product_name: [] })

    }


    return (
      <div className="filter-action-btn">
        <Button label="Clear" className="outline-icon-btn mr-2" onClick={handleClear} />
        <Button label="Apply" className="outline-active-btn" onClick={() => {
          // if (payloadData.product_name.length === 0) return showProductError()
          fetchGridData(payloadData)
          dynamicProductRef.current.hide()
        }} />
      </div>)

  }

const createDynamicColumns = (response: any) => {
  // Get the keys of the first object in the response to get column fields
  const keys = Object.keys(response);

  // Map over the keys and create the columns
  const columns = keys.map((key) => {
    if (key !== "percentage_difference") {


      const formattedKey = key.replace(/_/g, ' '); // Replace underscores with spaces
      return {
        field: key,
        header: formattedKey.charAt(0).toUpperCase() + formattedKey.slice(1), // Capitalize the first letter
      };
    }

    return null; 
  }).filter(column => column !== null); 


  columns.push({
    field: 'action',
    header: 'Action',
  });

  return columns;
};


  const handleActionClick = async (rowData: any) => {
    // setExpandedRows([])
    const payload: DynamicPricingDataPayload = { ...payloadData, product_name: [rowData.product_name] }
    try {

      dispatch(handleLoader(true))

      const { result, error } = await getDynamicPricingGraphData(payload)
      if (error) {
        throw error
      }

      setDynamicGraphData(result)

      dispatch(handleLoader(false))
    } catch (error: any) {
      dispatch(handleLoader(false))
      toast.error(error, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      })
    }

    setExpandedRows((prev) =>
      prev.some((row) => row.product_name === rowData.product_name)
        ? prev.filter((row) => row.product_name !== rowData.product_name) // Collapse
        : [rowData] // Expand
    );


  }



  const rowExpansionTemplate = (rowData: any) => {
    return (<>
      {dynamicGraphData && <DynamicGraph dynamicGraphData={dynamicGraphData} />}
    </>


    );
  };



  return (<>
    <Toast ref={toastRef} />
    <div className='p-4 content-wrapper w-100'>
      <div className="d-flex align-items-center justify-content-between flex-wrap mb-4">
        <div className='table-right-end mt-1 mb-1'>
          <Button className='outline-icon-btn outline-active-btn' style={{visibility: "hidden"}} outlined label='Approve' onClick={() => {
            console.log(selectedCustomers);
          }} />
        </div>
        <div className='d-flex flex-wrap'>
          <div className="d-flex align-items-center mr-3 mt-1 mb-1 pro-tab-wrap">
            <span className={`pro-tab ${!SearchByName ? 'active' : ""}`} onClick={() => setSearchByName(false)}>Product Id</span>
            <span className={`pro-tab ${SearchByName ? 'active' : ""}`} onClick={() => setSearchByName(true)}>Product Name</span>
          </div>
          <div className="d-flex align-items-center mt-1 mb-1 outer-box-border">
            <span className="outer-box-label">Product: </span>
            <MultiSelect
              value={payloadData.product_name}
              style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none" }}
              onChange={(e: MultiSelectChangeEvent) =>
                setPayloadData({ ...payloadData, product_name: e.value })}
              name={"dynamic-product"}
              id={"dynamic-product"}
              placeholder="All"
              optionLabel="product_name"
              optionValue="product_name"
              options={temp_unique_products}
              itemTemplate={productItemTemplate}
              maxSelectedLabels={0}
              panelFooterTemplate={() => productFooterTemplate()}
              resetFilterOnHide={true}
              className="outline-select multi-select product-select"
              ref={dynamicProductRef}
              virtualScrollerOptions={{ itemSize: 24, className: "virtual-multi-select" }}
              filter
            />
          </div>
        </div>
      </div>
      <div className='user-management-section'>
        <div className='datatable-wrapper'>
          {dynamicGridData?.result && dynamicGridData?.result.length > 0 ? (
            <DataTable
              value={dynamicGridData?.result ?? []}
              scrollable
              globalFilterFields={['product_id', 'product_name']} // Only filter by these fields
              className=''
              scrollHeight='550px'
              selectionMode='checkbox'
              selection={selectedCustomers}
              onSelectionChange={(e) => setSelectedCustomers(e.value)}
              rowExpansionTemplate={rowExpansionTemplate}
              expandedRows={expandedRows}
              onRowToggle={(e: any) => setExpandedRows(e.data)}
            >
              <Column selectionMode="multiple" style={{ width: '3em' }} />
              {columns.length > 0 && columns.map((col: {
                field: string, header: string
              }, indx: number) => (
                col.header === "Action" ? (
                  <Column
                    key={indx}
                    header={col.header}
                    body={(rowData) => (
                      <img
                        src={dynamicActionButton}
                        alt="Action"
                        style={{ cursor: 'pointer', width: '20px', height: '20px' }}
                        onClick={() => handleActionClick(rowData)}
                      />
                    )}
                  />
                ) : (col.header.includes("New price") ?
                  <Column
                    key={indx}
                    header={()=>{
                      const firstPart = col.header.split(" ").slice(0,2).join(" ")
                      const secondPart = col.header.split(" ").slice(2, -1).join(" ")
                      return <>
                      <span>{firstPart}</span> <br/>
                      <span>({secondPart})</span>
                      </>
                    }}
                    className='new-price'
                    body={(rowData) => {
                      const matchedItem = dynamicGridData?.result.find(
                        (item) => item.product_name === rowData.product_name
                      );

                      const sign = matchedItem?.percentage_difference[0]
                      const percentValue = parseFloat(matchedItem?.percentage_difference.substring(1));
                      const setColor = percentValue === 0 ? "blue" : (sign === "+" ? 'green' : "red")
                      return (
                        <>
                          <span className='mr-2'>{rowData[col.field]}</span>
                          <span className={setColor}>{matchedItem?.percentage_difference ?? ''}</span>
                        </>
                      );
                    }}
                  />
                  : ( (col.header.includes("Previous price") ?
                  <Column
                    key={indx}
                    sortable
                    header={()=>{
                      const firstPart = col.header.split(" ").slice(0,2).join(" ")
                      const secondPart = col.header.split(" ").slice(2, -1).join(" ")
                      return <>
                      <span>{firstPart}</span> <br/>
                      <span>({secondPart})</span>
                      </>
                    }}
                    className='previous-price'
                    field={col.field}
                  />   
                                 
                  :
                  <Column key={col.field} field={col.field} header={col.header} sortable />
                  ))
              )))}
            </DataTable>
          ) : (
            <div className='custom-empty-message'>No records available for this selection</div>
          )}
          {dynamicGridData?.result.length! > 0 && <Paginator
            first={first}
            rows={payloadData.size_limit}
            totalRecords={dynamicGridData?.total_count ?? 10}
            onPageChange={(e: any) => {
              setFirst(e.first)
              setPayloadData((prev: any) => {
                return { ...prev, size_limit: e.rows, page: e.page + 1 }
              })

            }}
            className="p-paginator-bottom"
            rowsPerPageOptions={[25, 50, 100]}
          />}
        </div>
      </div>
    </div>
  </>
  )
}

export default DynamicPricing

